<template>
  <div class="permission-list">
    <div v-for="(row, rowIndex) in permissions" :key="rowIndex" class="permission-list__row">
      <div class="permission-list__row__title">
        {{ row.title }}
      </div>
      <div class="permission-list__row__default">
        <m4-switch @update:modelValue="(val) => inputRow(row.name, val)" :name="row.name" :value="!!newValue[row.name]">
          Custom
        </m4-switch>
      </div>
      <div :class="rowClasses(row.name)">
        <div v-for="(permission, index) in row.items" :key="index" class="permission-list__row__items__item">
          <m4-switch
            @update:modelValue="(val) => inputPermission(permission.name, val)"
            :name="permission.name"
            :value="!!newValue[permission.name]"
          >
            {{ permission.title }}
          </m4-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4PermissionList",
  data() {
    return {
      newValue: this.value ? this.value : {}
    };
  },
  props: {
    permissions: Array,
    value: Object
  },
  methods: {
    rowClasses(rowName) {
      let classes = ["permission-list__row__items"];
      if (!this.newValue[rowName]) {
        classes.push("permission-list__row__items--disabled");
      }
      return classes;
    },
    inputRow(rowName, val) {
      let rowItem = this.permissions.find((item) => {
        return item.name === rowName;
      });

      if (rowItem) {
        let rowValue = {};
        if (val) {
          rowValue[rowName] = val;
        } else {
          rowValue[rowName] = val;
        }

        rowItem.items.forEach((permission) => {
          rowValue[permission.name] = val;
        });

        this.newValue = Object.assign({}, this.newValue, rowValue);
      }
    },
    inputPermission(permissionName, val) {
      this.newValue = Object.assign({}, this.newValue, {
        [permissionName]: val
      });
    }
  }
};
</script>
